import React from "react";
import Skills from "@frontend/app/landing/Skills.tsx";
import FadeUp from "@frontend/app/anims/FadeUp.tsx";

const LandingPage = () => {
  return (
    <span className="flex flex-col gap-16 pt-10 md:pt-24 pb-10">
      <FadeUp>
        <section className="text-left flex flex-col gap-10 md:gap-16 wait-for-splash">
          <h1 className="text-2xl md:pl-10">
            {/*<i className="pl-1">Hi, I'm</i> <br />*/}
            <span className="flex flex-col gap-y-3 ">
              <span className="text-7xl text-indigo-300 w-1/2">MJ Kochuk</span>
              <i className="pl-2 text-3xl ">Front End Engineer</i>
            </span>
          </h1>
          <span className="md:ml-12 md:mr-[33%] text-l wait-for-splash">
            <p>
              I’m a seasoned Frontend Engineer with a track record of transforming complex ideas
              into high-impact, scalable products. Across roles in AI, e-commerce, and data-driven
              organizations, I’ve led the development of real-time systems using WebSockets and
              IndexedDB, designed robust schema-based rendering engines, and modernized legacy APIs
              to streamline security and performance. My passion lies in delivering flawless user
              experiences—whether I’m orchestrating front-end architectures using React and Next.js,
              leveraging cloud services (AWS, GCP, Firebase) to handle massive user bases, or
              architecting data-driven dashboards for critical, real-time insights.
            </p>
            <br />
            <p>
              As a leader, I thrive on guiding cross-functional teams, bridging technical gaps, and
              championing best practices so that junior and senior engineers alike can excel. My
              background includes shaping test strategies (Cypress, Jest, Jasmine), enforcing secure
              authentication flows (OAuth, Passport, JWT), and employing agile methodologies to keep
              teams agile, aligned, and consistently delivering. I’m at my best when I’m
              collaborating with stakeholders—translating cutting-edge product visions into
              tangible, seamless experiences that delight end users and drive meaningful business
              outcomes.
            </p>
          </span>
        </section>
        <Skills />
      </FadeUp>
    </span>
  );
};

export default LandingPage;
